import { render, staticRenderFns } from "./teamaterial.vue?vue&type=template&id=27c2a007&scoped=true&"
import script from "./teamaterial.vue?vue&type=script&lang=js&"
export * from "./teamaterial.vue?vue&type=script&lang=js&"
import style0 from "./teamaterial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./teamaterial.vue?vue&type=style&index=1&id=27c2a007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2a007",
  null
  
)

export default component.exports